import { render, staticRenderFns } from "./app-sidebar.vue?vue&type=template&id=5941a4af&scoped=true"
import script from "./app-sidebar.vue?vue&type=script&lang=ts"
export * from "./app-sidebar.vue?vue&type=script&lang=ts"
import style0 from "./app-sidebar.vue?vue&type=style&index=0&id=5941a4af&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5941a4af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5941a4af')) {
      api.createRecord('5941a4af', component.options)
    } else {
      api.reload('5941a4af', component.options)
    }
    module.hot.accept("./app-sidebar.vue?vue&type=template&id=5941a4af&scoped=true", function () {
      api.rerender('5941a4af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/partials/app-sidebar.vue"
export default component.exports